export default {
    when() {
        return document.querySelectorAll('.section-cards-services').length > 0;
    },

    mounted() {
        const accordionHeader = document.querySelectorAll('.accordion-header');
        let accordionBoxes = document.querySelectorAll('.accordion-box');
        accordionHeader.forEach((header) => {
            header.addEventListener(
                'click',
                function () {
                    // reinitialize
                    
                    accordionBoxes.forEach((box) => {
                        box.classList.add('hidden');
                        box.style.maxHeight = '0px';
                    });
                    // remove active card
                    accordionHeader.forEach((accHeader) => {
                        accHeader.children[0].children[0].classList.remove(
                            'dynamic-card-active'
                        );
                        accHeader.children[0].children[0].classList.add(
                            'dynamic-card'
                        );
                    });
                    let headerCard = header.children[0].children[0];

                    headerCard.classList.add('dynamic-card-active');
                    headerCard.classList.remove('dynamic-card');

                    // get content
                    let accordionContent =
                        header.parentElement.querySelector(
                            '.accordion-content'
                        ).innerHTML;

                    let accordionContentTitle =
                        header.parentElement.querySelector(
                            '.accordion-content-title'
                        ).innerHTML;

                    // Content Accordion Box
                    let placeholder = header.parentElement.nextElementSibling;
                    let accordionBox;
                    let topHeader = header.offsetTop;
                    // Cette loop while recherche le bon accordion-box à afficher
                    // Pour savoir quel est le bon, il boucle toutes les cartes jusqu'à ce qu'une carte soit placé à la ligne suivante (permet de gérer les breakpoints)
                    while (placeholder) {
                        if (
                            !placeholder.classList.contains('accordion-box') &&
                            topHeader !== placeholder.offsetTop
                        ) {
                            accordionBox = placeholder.previousElementSibling;
                            break;
                        } else {
                            accordionBox = placeholder;
                        }
                        placeholder = placeholder.nextElementSibling;
                    }
                    //accordion Box display and animation
                    accordionBox.classList.remove('max-h-0');
                    accordionBox.querySelector('.accordion-text').innerHTML =
                        accordionContent;
                    accordionBox.querySelector('.accordion-title').innerHTML =
                        accordionContentTitle;
                    let accordionMaxHeight = accordionBox.style.maxHeight;
                    // Condition handling
                    if (
                        accordionMaxHeight == '0px' ||
                        accordionMaxHeight.length == 0
                    ) {
                        accordionBox.classList.remove('hidden');
                        accordionBox.style.maxHeight = `${
                            accordionBox.scrollHeight + 32
                        }px`;
                        accordionBox.classList.add('animate-slide-in-top');

                        //   header.querySelector('.fas').classList.remove('fa-plus');
                        //   header.querySelector('.fas').classList.add('fa-minus');
                        // header.parentElement.classList.add('bg-indigo-50');
                        header.classList.remove('border-b');
                    } else {
                        accordionBox.style.maxHeight = `0px`;
                        //   header.querySelector('.fas').classList.add('fa-plus');
                        //   header.querySelector('.fas').classList.remove('fa-minus');
                        accordionBox.classList.remove('animate-slide-in-top');
                    }

                    // Add Accordion Icon
                    let accordionIcon = null;
                    let accordionIconClasses =
                        header.querySelector('.accordion-icon').className;
                    console.log(accordionIconClasses);
                    accordionIcon = accordionBox.querySelector('i');
                    console.log(accordionIconClasses);
                    accordionIcon.className =
                        accordionIconClasses + ' text-primary-500 mb-6 ';
                    accordionIcon.classList.remove('text-xl');
                    accordionIcon.classList.add('text-4xl');

                    // Accordion triangle
                    // Get the value for the card (header) parent to find the left value for the card css 'left: px' relative to his parent
                    let triangle = accordionBox.querySelector(
                        '.accordion-triangle'
                    );
                    let triangleSemiWidth = 0;
                    let trianglePosition = 0;
                    // get padding of the header parent
                    let headerPaddingLeft = parseFloat(
                        window
                            .getComputedStyle(header.offsetParent, null)
                            .getPropertyValue('padding-left')
                    );
                    triangleSemiWidth = header.offsetWidth / 2;
                    let trianglePositionLeft =
                        header.offsetLeft - headerPaddingLeft;
                    trianglePosition = triangleSemiWidth + trianglePositionLeft;
                    /* -20 because the accordion-icon is 40px width */
                    triangle.style.left = trianglePosition - 20 + 'px';

                    //Accordion close button
                    let closeButton = accordionBox.querySelector(
                        '.accordion-box-icon'
                    );
                    closeButton.addEventListener('click', () => {
                        accordionBox.classList.remove('flex');
                        accordionBox.classList.add('hidden');
                        headerCard.classList.remove('dynamic-card-active');
                        headerCard.classList.add('dynamic-card');
                    });
                    accordionBox.scrollIntoView();
                },
                { passive: true }
            );
        });
    },
};
